import { render, staticRenderFns } from "./app-switch-toggle.vue?vue&type=template&id=2f642a7a&scoped=true&"
import script from "./app-switch-toggle.vue?vue&type=script&lang=js&"
export * from "./app-switch-toggle.vue?vue&type=script&lang=js&"
import style0 from "./app-switch-toggle.vue?vue&type=style&index=0&id=2f642a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f642a7a",
  null
  
)

export default component.exports